<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="Política de privacidad" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Xero Place Co., Ltd. (en adelante denominada "la Compañía") requiere que los usuarios proporcionen una cantidad mínima de información personal para que puedan utilizar el sitio con tranquilidad.</span>
            <span class="text">Además, ponemos el máximo cuidado en proteger la información personal que nos proporciona.</span>
            <span class="text">El enfoque de nuestra empresa respecto de la protección de la información personal es el siguiente.</span>
            <br>
            <span class="text">(1) La Compañía utilizará la información de individuos, organizaciones y corporaciones registradas por miembros solo para desarrollar y proporcionar funciones y servicios de vanguardia, y prestará mucha atención a la protección de la información personal de los miembros.</span>
            <span class="text">(2) Esta política de privacidad se aplica únicamente a los servicios proporcionados por nuestra empresa.</span>
            <span class="text">(3) Salvo lo especificado en estos Términos, la información no se utilizará para ningún otro propósito.</span>
            <span class="text">(4) Excepto lo especificado en estos Términos, no divulgaremos su información a terceros.</span>
            <span class="text">(5) Realizaremos periódicamente una gestión adecuada utilizando otros métodos estipulados en estos Términos.</span>
            <span class="text">(6) Nuestra empresa puede cambiar la política de privacidad sin el permiso del usuario.</span>
            <span class="text">Cuando nuestra empresa realice cambios en el contenido de la información personal adquirida, métodos de uso, cambios en el contenido de divulgación, etc., se lo notificaremos publicando un aviso en nuestro sitio web y reflejándolo en esta política de privacidad para que los usuarios puedan conocer el contenido.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Sección 1. Ámbito de aplicación de nuestra política de privacidad</span>
            <span class="text">(1) Nuestra política de privacidad se aplica cuando los miembros utilizan nuestros servicios.</span>
            <span class="text">(2) La información personal recopilada cuando los miembros utilizan nuestros servicios se gestionará de acuerdo con la política de nuestra empresa sobre protección de información personal.</span>
            <span class="text">(3) Nuestra política sobre protección de información personal se aplica únicamente a los servicios proporcionados directamente por nuestra empresa y no se aplica a los servicios proporcionados por otras organizaciones o empresas.</span>
            <span class="text">(4) El uso de nuestros servicios es bajo el propio riesgo del usuario.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Sección 2. Recopilación y uso de nuestra información personal</span>
            <span class="text">(1) Para desarrollar y proporcionar funciones y servicios de vanguardia a nuestros miembros, requerimos cierta información personal de nuestros usuarios.</span>
            <span class="text">(2) Los usuarios son responsables de administrar su dirección de correo electrónico registrada y su contraseña.</span>
            <span class="text">1. Cambie su contraseña periódicamente y no recomendamos utilizar nombres, fechas de nacimiento, números de teléfono, etc. que sean fáciles de adivinar para otros.</span>
            <span class="text">2. Por favor no revele, preste ni transfiera su información personal, incluso si es a un conocido o amigo.</span>
            <span class="text">(3) La información personal recopilada se utilizará únicamente en la medida necesaria para proporcionar nuestros servicios y no se proporcionará a ningún tercero, excepto en los siguientes casos.</span>
            <span class="text">1. Cuando una compañía de tarjetas de crédito realiza una consulta para investigar el uso fraudulento de tarjetas.</span>
            <span class="text">2. Al enviar correos electrónicos, etc. para publicidad a los miembros.</span>
            <span class="text">3. Al confiar el manejo de información personal a un subcontratista con el que hemos celebrado un acuerdo de confidencialidad sobre información personal en la medida necesaria para lograr el propósito de uso especificado para el usuario.</span>
            <span class="text">4. Cuando se considere necesario proteger los derechos o la propiedad de otros miembros, terceros o la Compañía, en caso de que las acciones de un miembro en la Compañía violen las políticas, los anuncios o los Términos de uso de la Compañía.</span>
            <span class="text">5. Cuando se solicite la divulgación de información personal conforme a lo dispuesto en otras leyes, como órdenes de un tribunal o agencia administrativa, o cuando exista la necesidad de investigación penal, eliminación o prevención de infracción de derechos contra terceros, u otra necesidad similar.</span>
            <span class="text">(4) Los miembros deberán aceptar de antemano el uso de la información personal por parte de la Compañía en la forma especificada anteriormente y no deberán plantear ninguna objeción.</span>
            <span class="text">(5) Además, podemos compartir la información personal de los miembros con nuestros socios comerciales en los siguientes casos:</span>
            <span class="text">1. Cuando exista un motivo de negocio, como servicios especiales para los socios. En este caso, solicitaremos el consentimiento del miembro antes de proporcionar la información y no proporcionaremos la información sin su consentimiento.</span>
            <span class="text">2. Al crear materiales estadísticos, realizar investigaciones de mercado o realizar análisis de datos. En este caso, solo proporcionaremos información que haya sido procesada de manera que no se pueda identificar a personas específicas.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
